import Link from "@mui/material/Link";
import * as config from "../../../config/config";
import { Fragment, useEffect, useState } from "react";
import { useSpring } from "@react-spring/web";
import { generateDeviceType } from "../../../helpers/data_management";
import Button from "../../shared/SharedButton/SharedButton";
import {
  AppDownloadContent,
  ContinueText,
  OverlayBackground,
  Title,
  TitleContainer,
  ContentContainer,
  RowContainer,
  RowLeft,
  RowRight,
  IconPurple,
  IconGrey,
  RowLabel,
  BottomLinkContainer,
  BrowserIcon,
} from "./styles";

const SharedDownloadAppBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const deviceType = generateDeviceType();

  // React Spring animation for download app banner
  const animateDownloadAppBanner = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    delay: 500,
    config: { duration: 500 },
  });

  useEffect(() => {
    if (
      (deviceType == "web_mobile_ios" || deviceType == "web_mobile_android") &&
      sessionStorage.getItem("mobileAppBanner") == null
    ) {
      setShowBanner(true);
      sessionStorage.setItem("mobileAppBanner", "true"); // Only show download app banner once per session
    }
  }, []);

  const handleClick = () => {
    sessionStorage.setItem("mobileAppBanner", "false"); // Only show download app banner once per session
    setShowBanner(false);
  };

  return (
    <Fragment>
      {showBanner ? (
        <OverlayBackground>
          <AppDownloadContent style={animateDownloadAppBanner}>
            <TitleContainer>
              <Title>Apply for jobs on the go! It's easier on the Hiredly App</Title>
            </TitleContainer>

            <ContentContainer>
              <RowContainer>
                <RowLeft>
                  <IconPurple
                    src={config.assetDomain + "/images/hiredly/hiredly-app.png"}
                    alt="hiredly-app"
                  />
                  <RowLabel>Hiredly Jobs</RowLabel>
                </RowLeft>
                <RowRight>
                  <Link
                    underline={"none"}
                    href="https://links.hiredly.com/get-the-app"
                    rel="noopener"
                    target="_blank"
                  >
                    <Button
                      button_type={"SolidPurple"}
                      id={"mobile-download-app-button"}
                    >
                      Open
                    </Button>
                  </Link>
                </RowRight>
              </RowContainer>

              <RowContainer>
                <RowLeft>
                  <IconGrey>
                    <BrowserIcon />
                  </IconGrey>
                  <RowLabel>Browser</RowLabel>
                </RowLeft>
                <RowRight>
                  <Button
                    button_type={"OutlinedBlack"}
                    id={"mobile-continue-web-button"}
                    onClick={handleClick}
                  >
                    Continue
                  </Button>
                </RowRight>
              </RowContainer>

              <BottomLinkContainer>
                <Link
                  underline="none"
                  href="https://hiredly.com/employer"
                  rel="noopener"
                  target="_blank"
                >
                  <ContinueText>
                    Hiring? Visit Hiredly for employers
                  </ContinueText>
                </Link>
              </BottomLinkContainer>
            </ContentContainer>
          </AppDownloadContent>
        </OverlayBackground>
      ) : null}
    </Fragment>
  );
};

export default SharedDownloadAppBanner;
